module.exports = __webpack_public_path__ + "static/media/emptyfolder.feb5d5d6.png";